import type { FieldValues, UseFormReturn } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';

const useOptionalFormContext = <
  TFieldValues extends FieldValues = FieldValues,
>(): UseFormReturn<TFieldValues> | null => {
  try {
    return useFormContext<TFieldValues>();
  } catch {
    return null;
  }
};

export default useOptionalFormContext;
